import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {

  private config: { [key: string]: any } = {};
  private env: { [key: string]: any } = {};

  constructor(private http: HttpClient) {
  }

  getHttp(): HttpClient {
    return this.http;
  }

  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: string) {
    return this.config[key];
  }


  /**
   * Use to get the data found in the first file (env file)
   */
  public getEnv(key: any) {
    return this.env[key];
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */
  load(): Observable<boolean> {
    let w_config = environment ? environment.configPath : './assets/config/env.json'
    return this.http.get(w_config).pipe(
      catchError(error => {
        console.error('Error loading env.json:', error);
        return of(null);
      }),
      tap((envResponse: any) => {
        this.env = envResponse;
      }),
      map(() => true),
      catchError(error => {
        console.error('Error loading configuration:', error);
        return of(false);
      })
    );
  }

}
